import { EThemeKey } from '@constants';
import React, { useEffect } from 'react';

import { useThemeControl } from './ThemeProvider';

import { useAcademy } from '@/store/academies/useAcademy';
import { useProfile } from '@/store/profile/useProfile';

export const ThemeSync: React.FC = () => {
  const { profile } = useProfile();
  const academyId = profile?.academy?._id;
  const { academy } = useAcademy(academyId);
  const { setThemeKey } = useThemeControl();

  useEffect(() => {
    const key = academy?.config?.themeConfig?.themeKey || EThemeKey.DEFAULT;
    setThemeKey(key);
  }, [academy, setThemeKey]);

  return null;
};
